<template>
  <div class="activity-intro">
   <div>
   <div>
   <img src="../../../assets/hdjjTitleBg1.png" class="hdjjTitleBgImg1"/>
   </div>
   <div>
     <img src="../../../assets/hdjjTitleBg2.png" class="hdjjTitleBgImg2"/>
   </div>
   <div class="titleRemark">
   {{gameName}}新动能科技成果推荐活动
   </div>
   </div>
    <div class="hdjjContentBg">
    <div class="hdjjBgDiv">
    <img src="../../../assets/hdjjBg.png" class="hdjjBg"/>
    </div>
    <div class="hdjjContentText" v-html="checkDate.introduction">
    
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityIntro",
    data() {
    return {
      checkDate:{},
      game_id:''
    }
    },
     mounted() {
    this.game_id = this.$route.query.id
    this.gameName = this.$route.query.name
    this.getCheckDate(this.game_id)
  },
    watch: {
    $route(to, from) {
      if (to.query.id !== this.game_id) {
        this.game_id = to.query.id
        this.getCheckDate()
        this.gameName = this.$route.query.name
      }
    }
  },

  methods: {
    getCheckDate(){
      this.$API.getCurrGames({id: this.game_id}).then(res => {
        this.checkDate = res.data
      })
    },
  }
};
</script>

<style scoped>
.titleRemark{
  color: #1E2454;
  font-weight: bold;
  font-size: 36px;
}
.hdjjTitleBgImg2{
  width: 435px;
  height: 68px;
  margin-top: 20px;
}
.hdjjTitleBgImg1{
  width: 322px;
  height: 37px;
  margin-top: 50px;
}
.hdjjContentText{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #5E6A7A;
line-height: 30px;
padding: 0 44px 40px 44px;
height: 480px;
display: -webkit-box;
-webkit-line-clamp: 16;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
}
.hdjjBgDiv{
  display: flex;
  justify-content: center;
}
.hdjjBg{
  width: 310px;
  height: 70px;
  margin-top:40px;
  margin-bottom: 30px;
}
.hdjjContentBg{
  background-image: url('../../../assets/hdjjContentBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 1200px;
  height: 644px;
  margin-top: 40px;
  margin-bottom: 30px;
}
.hdjjTitleBgImg{
width: 686px;
height: 181px;
margin-top: 50px;
}

</style>
